import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { GroupUsersSearch } from '../inputs/group_users_search'
import { OwnersSearch } from '../inputs/owners_search'

export const UserGroupScope = ({
  selectedOwnerIds, setSelectedOwnerIds,
  selectedUserIds, setSelectedUserIds,
}) => (
  <>
    <BodyText>
      {I18n.t('publisher.event_types.filters.description.group')}
    </BodyText>

    <OwnersSearch selectedIds={selectedOwnerIds} setSelectedIds={setSelectedOwnerIds} />
    <GroupUsersSearch selectedIds={selectedUserIds} setSelectedIds={setSelectedUserIds} />
  </>
)
